/** Превью ткани для сеток. Полный файл остаётся для увеличения. */
export function productThumbUrl(url: string): string {
  return url.replace(
    /\/products\/images\/(?!thumbs\/)([^/?#]+)\.[a-zA-Z0-9]+/,
    "/products/images/thumbs/$1.jpg",
  );
}

/** Кадр видео, чтобы карточка не ждала загрузки ролика. */
export function videoPosterUrl(url: string): string {
  return url.replace(
    /\/videos\/(?!posters\/)([^/?#]+)\.[a-zA-Z0-9]+/,
    "/videos/posters/$1.jpg",
  );
}
